import StopStatusCell from './container';

export default StopStatusCell;
